var invite = window.location.hash.substring(1);
document.getElementsByName('code')[0].value = invite;
console.log(invite);
document.querySelector('#login-show').addEventListener('click', toggleCode);

function toggleCode() {
  var codefield = document.getElementById('login-input');
  if(codefield.type == 'password') {
    codefield.type = 'text';
  } else {
    codefield.type = 'password';
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/login.js